import { useState, useEffect } from 'react';
// @mui
import { useNavigate } from "react-router-dom";
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
import { authKey, GET_USER_DETAILS, GET_STAKEHOLDER_BY_URN, GET_STAKEHOLDER_PHOTO, DOWNLOAD_DOCUMENT } from '../../../../common/URLs';
import { loaderService } from "../../../../common/custom-loader/loader-service";
import jwt from 'jwt-decode';
import { onSignOut } from '../../../../common/Utils';
import { getLocalStorageItem } from '../../../localStorageUtils';
import PhotoUpload from '../../../../common/common-sidebar/layout/header/UploadPhoto';
import { userData } from '../../../../common/spinLoader';
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { appInsights } from '../../../../AppInsights';
import apiClient from '../../../../axios';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  // const userLoggedIn = userData?.user?.userRoles?.[0].roleName
  const {t} = useTranslation();
  const [emailId, setEmailId] = useState();
  const [urn, setURN] = useState();
  const [file, setFile] = useState();
  const [stakeholderAccount, setStakeholderAccount] = useState();
  const [profilePhoto, setProfilePhoto] = useState();
  const [displayImage, setDisplayImage] = useState();
  const [updatePhoto, setUpdatePhoto] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleConfirmLogModalClose = () => setLogModalOpen(false);

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));
      const email = decoded.emails?.[0];
      localStorage.setItem('email', email);
      appInsights.setAuthenticatedUserContext(email);
      setEmailId(email);
      const URN = decoded.extension_URN;
      setURN(URN);
    }
  }, [getLocalStorageItem('id_token')]);


  useEffect(() => {
    if (emailId) {
      getUserDetails();
    }
  }, [emailId]);
  useEffect(() => {
    if (urn) {
      getStakeDetails();
      getStakeholderPhoto();
    }
  }, [urn]);

  // -----------------API Calls-------------------

  function getUserDetails() {
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": emailId
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        let displayName = [response.data.user.firstname, response.data.user.middlename, response.data.user.lastname]
          setAccount({ ...account, 'displayName': displayName.filter(part => part).join(' '), 'email': response.data.user.emailAddress })
          localStorage.setItem('userName', response.data.user.firstname + " " + (response.data.user.middlename?(response.data.user.middlename + " "):"") + response.data.user.lastname);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  function getStakeDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_STAKEHOLDER_BY_URN,
        {
          "urn": urn
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        const stakeholder = response.data.stakeHolder
        setAccount({ ...account, 'displayName': (stakeholder?.categoryName === "Grower" && stakeholder?.growerMasters?.[0]?.growerType === "Individual") ? stakeholder?.contactPersonFirstname + " " + stakeholder?.contactPersonMiddlename + " " + stakeholder?.contactPersonLastname : stakeholder?.name, 'urn': stakeholder.urn, 'email': stakeholder.categoryName })
        localStorage.setItem('userName', (stakeholder?.categoryName === "Grower" && stakeholder?.growerMasters?.[0]?.growerType === "Individual") ? stakeholder?.contactPersonFirstname + " " + stakeholder?.contactPersonMiddlename + " " + stakeholder?.contactPersonLastname : stakeholder?.name);
        setStakeholderAccount(response.data.stakeHolder)
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  function getStakeholderPhoto() {
    loaderService.showLoader();
    apiClient
      .post(GET_STAKEHOLDER_PHOTO,
        {
          "urn": urn,
          "type": " ",
          "includeRejected": true,
          "isScrutinyView": true

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setProfilePhoto(response.data.document);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  useEffect(() => {
    if (profilePhoto) {
      downloadDocument(profilePhoto?.documentBlobName, profilePhoto?.documentName, null);
    }
  }, [profilePhoto])

  const downloadDocument = (blobFileName, finalfileName, callback) => {
    loaderService.showLoader()
    return fetch(DOWNLOAD_DOCUMENT,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          AuthKey: authKey,
        },
        body: JSON.stringify({
          "fileName": blobFileName,
          "containerName": "stakeholder",
          "file": ""
        })
      })
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        const fileName = finalfileName
        const splittedName = fileName.split('.')
        const fileExtension = splittedName[splittedName.length - 1];
        let fileType;
        switch (fileExtension) {
          case 'pdf':
            fileType = 'application/pdf';
            break;
          case 'png':
            fileType = 'image/png';
            break;
          case 'jpg':
            fileType = 'image/jpeg';
            break;
          case 'jpeg':
            fileType = 'image/jpeg';
            break;
          default:
            fileType = 'application/octet-stream';
        }
        const x = new Blob([blob], { type: fileType });
        const url = URL.createObjectURL(x);
        setDisplayImage(url);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
      });

  }

  const [account, setAccount] = useState({
    displayName: ' ',
    email: ' ',
    photoURL: ' ',
    urn: ''
  })
  const [open, setOpen] = useState(null);


  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const navigate = useNavigate()
  const onChangePassword = () => {
    navigate("/changePasswordscreen")
  };

  const onUploadPhoto = () => {
    handleLogModalOpen();
    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <PhotoUpload accountDetails={stakeholderAccount} onClose={onClose} />
    //     );
    //   }
    // });

  }


  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar sx={{ width: 25, height: 25 }} src={displayImage} alt='profile Photo' />
      </IconButton>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
       {account?.urn && <Typography variant="subtitle2" noWrap mb={2}>
            {account?.urn}
          </Typography>}
          <Typography variant="subtitle2" noWrap>
            {account.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {/* {account.email} */}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {/* {userLoggedIn ? userLoggedIn : account?.categoryName} */}

          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />


        <Divider sx={{ borderStyle: 'dashed' }} />
        {stakeholderAccount &&
          <MenuItem onClick={onUploadPhoto} sx={{ m: 1 }}>
            {t('account.upload photo')}
          </MenuItem>
        }
        <MenuItem onClick={() => onChangePassword()} sx={{ m: 1 }}>
          {t('account.change password')}
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem onClick={() => onSignOut()} sx={{ m: 1 }}>
          {t('account.logout')}
        </MenuItem>
      </Popover>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
        <PhotoUpload accountDetails={stakeholderAccount} onClose={handleConfirmLogModalClose} />
        </DialogContent>
      </Dialog>
    </>
  );
}
